export default __webpack_public_path__ + "strongher-second-screens.1d50d455.png";